export default __webpack_public_path__ + "static/media/fishcrate.38a960cc.png";